/** Atributo en el botón de tema (luna/sol) del NavBar — usado por el aviso post-login */
export const WEMBII_DARK_MODE_TOGGLE_ATTR = "data-wembii-dark-mode-toggle";
